import {Injectable} from '@angular/core';
import {
  CanActivate, CanActivateChild, CanLoad,
  ActivatedRouteSnapshot, RouterStateSnapshot, Route
} from '@angular/router';

import { UserService} from '../services/user.service';
import { KindeAuthService } from '../services/kinde-auth.service';
import { AppStorage } from '../utilities/storage';
import { ACCESS_TOKEN_KEY } from '../shared/constants';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private userService: UserService,
    private kindeAuth: KindeAuthService,
  ) {
  }

  private async isLoggedIn(): Promise<boolean> {
    // Bridge code auth (admin impersonation) sets SZ tokens directly — no Kinde session
    const szToken = AppStorage.getTokenData(ACCESS_TOKEN_KEY);
    if (szToken) {
      return true;
    }

    const authenticated = await this.kindeAuth.isAuthenticated();
    if (authenticated) {
      return true;
    }
    this.userService.navigateToLogin();
    return false;
  }

  // skipcq: JS-0356
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.isLoggedIn();
  }

  // skipcq: JS-0356
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.isLoggedIn();
  }

  // skipcq: JS-0356
  canLoad(route: Route): boolean {
    // CanLoad must be synchronous — optimistically allow navigation.
    // The canActivate check above will do the authoritative async check.
    return true;
  }
}
